import { notify } from 'util/notify';

const OpenNotification = ({ type, title, ...rest }) => notify?.[type]?.({ message: title, ...rest });

export default OpenNotification;
